import { TableBody } from '@razorpay/blade/components';
import { SalaryStructure } from 'components/SalaryStructure/types';
import React from 'react';
import SalaryStructuresListTableRow from './SalaryStructuresListTableRow';

interface TableContentProps {
  structures: SalaryStructure[];
  onViewDetails: (structureId: string) => void;
}

const SalaryStructuresListTableContent: React.FC<TableContentProps> = ({
  structures,
  onViewDetails,
}) => {
  return (
    <TableBody>
      {structures.map((structure) => (
        <SalaryStructuresListTableRow
          key={structure.id}
          structure={structure}
          onViewDetails={onViewDetails}
        />
      ))}
    </TableBody>
  );
};

export default SalaryStructuresListTableContent;
